export const ADD_LOADING_API = 'loading/add_loading_api';
export const REMOVE_LOADING_API = 'loading/remove_loading_api';
export const CLEAR_DATA = 'loading/clear_data';

export type SettingAction = typeof ADD_LOADING_API | typeof REMOVE_LOADING_API | typeof CLEAR_DATA;
